import Axios from "./axios";

const axios = new Axios();

type UploadBlobSasResponse = {
  uploadUrl: string;
  publicUrl: string;
  blobPath: string;
};

function putBlobWithSas(uploadUrl: string, file: File): Promise<void> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("PUT", uploadUrl);
    xhr.setRequestHeader("x-ms-blob-type", "BlockBlob");
    xhr.setRequestHeader(
      "Content-Type",
      file.type || "application/octet-stream",
    );

    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve();
        return;
      }
      reject(new Error(`Blob upload failed with status ${xhr.status}`));
    };

    xhr.onerror = () => {
      reject(new Error("Blob upload failed due to a network error."));
    };

    xhr.send(file);
  });
}

export function shouldUploadBlobDirect(file: File): boolean {
  if (file.type.startsWith("video/")) {
    return true;
  }

  if (file.type === "application/pdf") {
    return true;
  }

  const extension = file.name.split(".").pop()?.toLowerCase();
  return extension === "pdf" || extension === "mp4" || extension === "webm" || extension === "mov";
}

export async function uploadBlobDirect(
  file: File,
  folderId: string,
  basePath = "help-center/",
): Promise<string | undefined> {
  try {
    const storagePath = `${basePath.replace(/\/+$/, "")}/${folderId}`;
    const response = await axios.Post("/upload-blob-sas", {
      path: storagePath,
      originalFileName: file.name,
      contentType: file.type || "application/octet-stream",
    });

    if (response.status !== 200) {
      return undefined;
    }

    const payload = response.data as UploadBlobSasResponse;
    if (!payload?.uploadUrl || !payload?.publicUrl) {
      return undefined;
    }

    await putBlobWithSas(payload.uploadUrl, file);
    return payload.publicUrl;
  } catch (error) {
    console.error("Direct blob upload failed:", error);
    return undefined;
  }
}
